<script>
import THelp from '~/components/THelp';

export default {
  extends: THelp,

  props: {
    label: {
      type: String,
      required: false,
      default:
        'Tragen Sie hier die URL der Startseite Ihrer Unternehmenswebsite ein. Es ist wichtig, dass die URL http:// oder https:// enthält. (z.B. https://www.muster.de)',
    },
  },
};
</script>
